import HighLightWords from "@dropDesk/presentation/components/high_light_words";
import React, {useEffect} from "react";
import {useInjection} from "inversify-react";
import {observer} from "mobx-react";
import SelectSearchRemote from "@dropDesk/presentation/components/inputs/select_search_remote";
import {ConstantsKeys} from "@dropDesk/domain/entities/constants/constants_keys";
import {Select} from "antd";
import {
    ContainerColumn,
    ContainerHeaderColumn,
    ContainerHeaderText,
    ContentColumn,
    TextMainEllipsis,
} from "./styled";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {setBlockUpdateLocalSearchCache} from "@dropDesk/utils/helpers/common";
import {
    SelectSearchSearchDescriptionStaticType
} from "@dropDesk/presentation/components/inputs/select_search_description_static/select_search_description_static";
import {
    TicketsDescriptionStaticController
} from "@dropDesk/presentation/pages/ticket_description_static/controller/ticket_description_static.controller";
import {displayDateToLocale} from "@dropDesk/utils/helpers/date_helper";
import {
    TicketsDescriptionStaticEntity
} from "@dropDesk/domain/entities/ticket_description_static/ticket_description_static.entity";
import ModalCrudTicketsDescriptionStatic
    from "@dropDesk/presentation/pages/ticket_description_static/ui/modals/modal_crud";
import {useBetween} from "use-between";
import {
    useModalSearchTicketsDescriptionStatic
} from "@dropDesk/presentation/pages/ticket_description_static/ui/modals/handle_change_visible";

const {Option} = Select;

const SelectSearchDescriptionStatic = observer((props: SelectSearchSearchDescriptionStaticType) => {


    const ticketsDescriptionStaticController = useInjection(TicketsDescriptionStaticController);

    const appController = useInjection(AppController);
    const colors = appController.theme.colorScheme;
    const {setVisibleModalNewTicketsDescriptionStatic} = useBetween(useModalSearchTicketsDescriptionStatic);

    useEffect(() => {
        initialize();
    }, []);

    const initialize = () => {
        ticketsDescriptionStaticController.setFilterListableForClients(appController.isUserClient ? 'true' : null);
        ticketsDescriptionStaticController.tableTicketsDescriptionStatic.limit = ConstantsKeys.defaultLimitSelectSearchItems;
    }

    const onSearch = (searchParam: string): void => {
        setBlockUpdateLocalSearchCache(true);
        ticketsDescriptionStaticController.list(searchParam ?? ticketsDescriptionStaticController.searchParam);
    }

    const onSuccessCreateDescriptionStatic = (key: string, descriptionStatic?: TicketsDescriptionStaticEntity) => {
        if (descriptionStatic && props.handleSaveNewDescriptionStatic) {
            props.handleSaveNewDescriptionStatic(descriptionStatic);
        }
        setVisibleModalNewTicketsDescriptionStatic(false);
    }

    const handleVisibleModalDescriptionStatic = (visible: boolean, id: string) => {
        setVisibleModalNewTicketsDescriptionStatic(visible);
    }


    const options =
        <>
            {ticketsDescriptionStaticController.tableTicketsDescriptionStatic.data.map(descriptionStatic => (
                <Option key={descriptionStatic.id} value={descriptionStatic.id}
                        label={descriptionStatic.description} data={descriptionStatic}>
                    <ContainerColumn>
                        <ContentColumn>
                            <TextMainEllipsis>
                                <HighLightWords
                                    searchWords={ticketsDescriptionStaticController.searchParam}
                                    textToHighlight={descriptionStatic.description}
                                    fontSize={13}
                                />
                            </TextMainEllipsis>
                        </ContentColumn>
                    </ContainerColumn>
                </Option>
            ))}
        </>

    const optionsHeader =
        <ContainerHeaderColumn>
            <ContainerHeaderText color={colors.hintInverse}>Descrição do
                problema</ContainerHeaderText>
        </ContainerHeaderColumn>


    return (
        <>
            <SelectSearchRemote<TicketsDescriptionStaticEntity>
                onChange={(filter, descriptionStatic) => {
                    props.handleSelectDescriptionStatic(filter, descriptionStatic);
                }}
                onClickRemoveFilter={() => {
                    ticketsDescriptionStaticController.tableTicketsDescriptionStatic.page = 0;
                }}
                required={props.required}
                iconLeftName={props.iconLeftName}
                borderColor={props.borderColor}
                disabled={props.disabled}
                onSearch={(value) => onSearch(value)}
                size={props.size}
                useRemoveFilter={props.useRemoveFilter}
                width={props.width}
                widthPopup={props.widthPopup ?? 632}
                label={props.label}
                placeHolder={props.placeHolder}
                value={props.value}
                useButtonRight={!props.hideButtonNewDescriptionStatic}
                labelButtonRight={"Novo problema"}
                onClickButtonRight={() => {
                    setVisibleModalNewTicketsDescriptionStatic(true);
                }}
                loading={ticketsDescriptionStaticController.loading}
                options={options}
                optionsLength={ticketsDescriptionStaticController.tableTicketsDescriptionStatic.data.length}
                search={true}
                searchValue={ticketsDescriptionStaticController.searchParam}
                hasMore={ticketsDescriptionStaticController.tableTicketsDescriptionStatic.hasMore}
                loadMore={() => ticketsDescriptionStaticController.loadMoreDataFromPage()}
                messageError={props.messageError}
                dropdownRender={menu => (
                    <>
                        {optionsHeader}
                        {menu}
                    </>
                )}
            />

            <ModalCrudTicketsDescriptionStatic
                onUpdate={(descriptionStatic) => ticketsDescriptionStaticController.setTicketsDescriptionStatic(descriptionStatic)}
                ticketsDescriptionStatic={ticketsDescriptionStaticController.ticketsDescriptionStatic ?? ticketsDescriptionStaticController.newTicketsDescriptionStatic}
                loading={ticketsDescriptionStaticController.loading}
                handleVisibleModalNewTicketsDescriptionStatic={handleVisibleModalDescriptionStatic}
                set={async () => ticketsDescriptionStaticController.set(onSuccessCreateDescriptionStatic)}
            />
        </>

    )
});
export default SelectSearchDescriptionStatic;
